import { Button, useDialogContext, useStoreState } from "@ariakit/react";
import { LetterheadSubmitError, useForm } from "@indietabletop/appkit";
import { circularButton } from "../../common/common.css.ts";
import { database } from "../../database.ts";
import { FormDialog, FormDialogActions } from "../FormDialog/FormDialog.tsx";
import { FormDialogSubmitButton } from "../forms/DialogSubmitButton.tsx";
import { Bottle, Cap } from "../GangPage/Cap.tsx";
import { useGitContext } from "../GangPage/ModelContext.tsx";
import { useGangContext } from "../GangPage/useGang.ts";
import { stepper } from "./style.css.ts";

export function ModifyStashDialog() {
  const { gang } = useGangContext();
  const dialog = useDialogContext();

  const { form, submitName } = useForm({
    defaultValues: {
      caps: 1,
    },
    async onSubmit({ values }) {
      const { data } = gang.modifyStash(values.caps);
      return database.gangs.updateOne(data);
    },

    onSuccess() {
      dialog?.hide();
    },
  });

  const caps = useStoreState(form, (state) => state.values.caps);

  const decrementCaps = () => {
    const nextValue = caps === 1 ? -1 : caps - 1; // Skip 0
    form.setValue(form.names.caps, nextValue);
  };

  const incrementCaps = () => {
    const nextValue = caps === -1 ? 1 : caps + 1; // Skip 0
    form.setValue(form.names.caps, nextValue);
  };

  return (
    <FormDialog overline="City of Gnork" heading="Income Statememt" form={form}>
      <div className={stepper.container}>
        <Button
          className={circularButton({ theme: "beige" })}
          onClick={decrementCaps}
        >
          -
        </Button>

        <Cap
          diff={caps}
          cost={gang.stash}
          label="Stash"
          additionalInfo="Caps"
          size={stepper.mainSize}
        />

        <Button
          onClick={incrementCaps}
          className={circularButton({ theme: "beige" })}
        >
          +
        </Button>
      </div>

      <FormDialogActions>
        <LetterheadSubmitError name={submitName} />

        <FormDialogSubmitButton>Save</FormDialogSubmitButton>
      </FormDialogActions>
    </FormDialog>
  );
}

export function ModifyAttitudeDialog() {
  const git = useGitContext();
  const dialog = useDialogContext();
  const { constants } = git.ruleset;

  const { form, submitName } = useForm({
    defaultValues: {
      diff: 1,
    },

    async onSubmit({ values }) {
      const maxDiff = constants.maxAttitude - git.attitude;
      const minDiff = constants.defaultAttitude + git.attitude * -1;
      const nextDiff = Math.min(Math.max(minDiff, values.diff), maxDiff);
      const nextGit = git.modifyAttitude(nextDiff);
      return database.gangs.updateOne(nextGit.gang.data);
    },

    onSuccess() {
      dialog?.hide();
    },
  });

  const value = useStoreState(form, (state) => state.values.diff);

  const decrementCaps = () => {
    const nextValue = value === 1 ? -1 : value - 1; // Skip 0
    form.setValue(form.names.diff, nextValue);
  };

  const incrementCaps = () => {
    const nextValue = value === -1 ? 1 : value + 1; // Skip 0
    form.setValue(form.names.diff, nextValue);
  };

  return (
    <FormDialog overline="City of Gnork" heading="Criminal Record" form={form}>
      <div className={stepper.container}>
        <Button
          className={circularButton({ theme: "beige" })}
          onClick={decrementCaps}
        >
          -
        </Button>

        <Bottle
          diff={value}
          cost={git.attitude}
          label="Attitude"
          size={stepper.mainSize}
        />

        <Button
          onClick={incrementCaps}
          className={circularButton({ theme: "beige" })}
        >
          +
        </Button>
      </div>

      <FormDialogActions>
        <LetterheadSubmitError name={submitName} />

        <FormDialogSubmitButton>Save</FormDialogSubmitButton>
      </FormDialogActions>
    </FormDialog>
  );
}
